var map = {
	"./LAWWDxIngersoll_LayersWeb_01.jpg": 39689,
	"./LAWWDxIngersoll_LayersWeb_02.jpg": 49630,
	"./LAWWDxIngersoll_LayersWeb_03.png": 59971,
	"./LAWWDxIngersoll_LayersWeb_04.jpg": 75707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48552;